import Chance from 'chance'

const chance = new Chance()

const _getId = () => chance.string({ length: 10, pool: "qwertyuiopasdfghjklzxcvbnm1234567890" }) 

const _createDoc = (collection, getId) => (initials, cb) => {
  const id = getId(initials)
  if (cb) cb(id)

  return {
    type: `CREATE_ONE_${collection}`,
    id, 
    payload: initials
  }
}

const _fetchCollection = (collection, getCollection, receiveAction, errorAction) => () => dispatch => {
  dispatch({ type: `FETCHING_ALL_${collection}` })
  getCollection((e, docs) => {
    if (e) { 
      console.error(`Error found while fetching ${collection}: ${e}`)
      dispatch(errorAction(e))
    }
    else dispatch(receiveAction(docs))
  })
}

const _fetchCollectionError = collection => e => ({
  type: `RECEIVE_ALL_${collection}`, error: true, payload: e
})

const _receiveCollection = collection => docs => ({
  type: `RECEIVE_ALL_${collection}`, payload: docs 
})

const _receiveDoc = collection => doc => ({
  type: `RECEIVE_ONE_${collection}`, id: doc._id, payload: doc
})

const _removeDoc = collection => id => ({
  type: `REMOVE_ONE_${collection}`, id 
})

const _updateDoc = collection => (id, changes) => ({
  type: `UPDATE_ONE_${collection}`, id, payload: changes
})

/**
 * you can only overload getId and createDoc. for now.
 */
export default function createActionSet(collection, getDoc, getCollection, overloads = {}) { 
  const getId = overloads.getId || _getId 
  return {
    ...overloads, 
    getId, 
    createDoc: overloads.createDoc || _createDoc(collection, getId),
    fetchCollection: _fetchCollection(collection, getCollection, _receiveCollection(collection), _fetchCollectionError(collection)), 
    receiveCollection: _receiveCollection(collection), 
    receiveDoc: _receiveDoc(collection), 
    removeDoc: _removeDoc(collection), 
    updateDoc: _updateDoc(collection) 
  }
}

